import { ColumnDef } from '@tanstack/angular-table';
import { TableDateCellComponent } from '@core/components/table/table-date-cell/table-date-cell.component';
import { TableColorCellComponent } from '@core/components/table/table-color-cell/table-color-cell.component';
import { flexRenderComponent } from '@tanstack/angular-table';
import { WithdrawalsHistory } from '../interfaces/withdrawals-history.interface';
import { TableButtonCellComponent } from '@core/components/table/table-button-cell/table-button-cell.component';
import { ClipboardService } from '@core/services/clipboard.service';
import { UserHistoryService } from '../services/user-history.service';
import { CostComponent } from '@core/components/cost/cost.component';

interface Props {
  copy: typeof ClipboardService.prototype.copy;
  userHistoryService: UserHistoryService;
}

export const withdrawalsHistoryTableConfig = ({
  copy,
  userHistoryService,
}: Props): ColumnDef<WithdrawalsHistory>[] => [
  {
    accessorFn: (row) => row.id,
    id: 'id',
    header: ({ column }) => {
      return {
        onClick: () => column.toggleSorting(),
        content: 'ID',
      };
    },
    cell: (cell) => cell.getValue(),
    enableSorting: true,
  },
  {
    accessorFn: (row) => row.offerid,
    id: 'offerid',
    header: ({ column }) => {
      return {
        onClick: () => column.toggleSorting(),
        content: 'Offer ID',
      };
    },
    cell: (cell) => cell.getValue(),
    enableSorting: true,
  },
  {
    accessorFn: (row) => row.hash,
    id: 'hash',
    header: ({ column }) => {
      return {
        onClick: () => column.toggleSorting(),
        content: 'Hash',
      };
    },
    cell: (cell) => {
      const hash = cell.getValue() as string;
      return {
        onClick: () => {
          copy(hash, 'Hash copied!');
        },
        content: hash,
      };
    },
    enableSorting: true,
  },
  {
    accessorFn: (row) => row.value,
    id: 'value',
    header: ({ column }) => {
      return {
        onClick: () => column.toggleSorting(),
        content: 'Value',
      };
    },
    cell: (cell) => {
      const value = cell.getValue() as number;
      return flexRenderComponent(CostComponent, {
        inputs: {
          cost: value,
          balanceType: 'skins',
          gap: 4,
          color: 'var(--yellow)',
        },
      });
    },
    enableSorting: true,
  },
  {
    accessorFn: (row) => row.date,
    id: 'date',
    header: ({ column }) => {
      return {
        onClick: () => column.toggleSorting(),
        content: 'Time',
      };
    },
    cell: (cell) => {
      const value = cell.getValue() as number;
      return flexRenderComponent(TableDateCellComponent, {
        inputs: {
          value,
        },
      });
    },
    enableSorting: true,
  },
  {
    accessorFn: (row) => row.status,
    id: 'status',
    header: ({ column }) => {
      return {
        onClick: () => column.toggleSorting(),
        content: 'Status',
      };
    },
    cell: (cell) => {
      const status = cell.cell.getValue() as string;
      const withdraw = cell.row.original;
      if (status === 'errored') {
        return flexRenderComponent(TableButtonCellComponent, {
          inputs: {
            text: 'Resend',
          },
          outputs: {
            handleClick: () =>
              userHistoryService.resendTrade(withdraw.id, -1, 'withdraws'),
          },
        });
      } else {
        const statuses = {
          acce: 'var(--green)',
          proc: 'var(--yellow)',
          fail: 'var(--red)',
          erro: 'var(--red)',
        };

        return flexRenderComponent(TableColorCellComponent, {
          inputs: {
            color: statuses[status.slice(0, 4) as keyof typeof statuses],
            value: status,
          },
        });
      }
    },
    enableSorting: true,
  },
];
